import { useMemo } from "react"
import { Text } from "../Typography"
import { Link } from "../Link"

export const apiErrorMessage = `We are sorry, something has gone wrong. Please try again later`

/** @TODO - We should store these in a JSON file, so they can be pulled into INTL later.. */
const specificErrorMessages = {
  /** Specific error responses */
  VEHICLE_NOT_MATCHED_TO_BAND_LINK: (
    <>
      {`One of your vehicles has not been underwritten before, please fill out `}
      <Link href="https://2a9bj.share.hsforms.com/2_dpQZTvzQCGdo3NxUhh8mA" target="_blank" rel="noopener noreferrer">
        this form
      </Link>
      {` to refer your vehicle directly to our Underwriting Team and our team will be in touch.`}
    </>
  ),
  VEHICLE_NOT_MATCHED_TO_BAND: `One of the vehicles you are trying to add has not previously been underwritten by Flock. Please contact your customer success manager to review the vehicles.`,
  INVALID_CHANGE: `One of the vehicles you are trying to add or update is backdated. Please contact your customer success manager to review the vehicles.`,
  /** Generic error responses */
  AUTH: `Your session has expired. Please re-authenticate to continue.`,
  FORBIDDEN: `You are not permitted to access this resource.`,
  INVALID: apiErrorMessage,
  MALFORMED: apiErrorMessage,
  NOT_FOUND: `The requested resouce was not found.`,
  UNKNOWN: apiErrorMessage,
} as const

export type SpecificErrorMessage = keyof typeof specificErrorMessages

interface ApiErrorProps {
  error?: SpecificErrorMessage
}

export const ApiError: React.FC<ApiErrorProps> = ({ error, ...props }) => {
  if (error) {
    // eslint-disable-next-line no-console
    console.error(`[API-ERROR] Recieved error `, error)
  }

  const errorToDisplay = useMemo(
    () => <Text {...props}>{error ? specificErrorMessages[error] ?? apiErrorMessage : apiErrorMessage}</Text>,
    [error, props]
  )

  return errorToDisplay
}

ApiError.defaultProps = {
  error: undefined,
}
